class PLPState {
    constructor() {
        if($('script[type="text/json"]#params').length > 0){
            this.state = JSON.parse($('script[type="text/json"]#params').text());
        } else {
            this.state = {};
        }
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new PLPState();
        }

        return this.instance;
    }

    add(key, value) {
        if (!(key in this.state)) {
            this.state[key] = [value.toLowerCase()];
        } else {
            if (!(this.state[key].includes(value.toLowerCase()))) {
                this.state[key].push(value.toLowerCase());
            }
        }
    }

    remove(key, value = false) {
        if (key in this.state) {
            if (value) {
                this.state[key] = this.state[key].filter(item => item !== value.toLowerCase());


                if (this.state[key].length === 0) {
                    delete this.state[key];
                }
            } else {
                delete this.state[key];
            }
        }
    }
}

export default PLPState;
